import React, { useEffect, useState } from 'react';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
  duration?: number;
}
// Check mobile once at module level to avoid repeated matchMedia calls
const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
export function FadeIn({
  children,
  delay = 0,
  direction = 'up',
  className = '',
  duration = 0.6
}: FadeInProps) {
  // On mobile, skip framer-motion entirely — render plain div
  if (isMobile) {
    return <div className={className} data-id="element-365">{children}</div>;
  }
  return <MotionFadeIn delay={delay} direction={direction} className={className} duration={duration} data-id="element-366">
      {children}
    </MotionFadeIn>;
}
// Separate component that imports framer-motion only when needed (desktop)
function MotionFadeIn({
  children,
  delay,
  direction,
  className,
  duration
}: FadeInProps) {
  const [MotionDiv, setMotionDiv] = useState<any>(null);
  useEffect(() => {
    import('framer-motion').then(mod => {
      setMotionDiv(() => mod.motion.div);
    });
  }, []);
  const directions = {
    up: {
      y: 40,
      x: 0
    },
    down: {
      y: -40,
      x: 0
    },
    left: {
      x: 40,
      y: 0
    },
    right: {
      x: -40,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  // Show content immediately while motion loads (prevents flash)
  if (!MotionDiv) {
    return <div className={className} data-id="element-367">{children}</div>;
  }
  return <MotionDiv initial={{
    opacity: 0,
    ...directions[direction || 'up']
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: duration,
    delay: delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-368">
      {children}
    </MotionDiv>;
}